import { QueryConfig } from "store/utils/query-config";

export const badgesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"],
  },
};
